import script from "./TeamMemberForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMemberForm.vue?vue&type=script&setup=true&lang=js"

import "./TeamMemberForm.vue?vue&type=style&index=0&id=0d00c103&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d00c103"]])

export default __exports__